import React, { Component } from 'react'
import "../../css/Nacionalidad.css"
import logo from "../../assets/logo_espol_interno.svg";
import ecuatoriano from "../../assets/Ecuatorianoblc.svg";
import extranjero from "../../assets/Extrangeroblc.svg";
import axios from "axios";
import FormRegistro from './FormRegistro';
import equis from "../../assets/eliminar.svg";
import check from "../../assets/check.svg";
import camaranecesaria from "../../assets/CAMARAnecesaria.svg";
import alarma from "../../assets/alarma.svg";
import transaccionexitosa from "../../assets/transaccionexitosa.svg";
import Modal from "../components/Modal";
import ModalXL from "../components/ModalXL";
import { Link, useLocation } from "react-router-dom";
import Cookies from 'js-cookie';
import info from "../../assets/Info.png"
import Header from '../components/Header.js'
//import SignupForm from '../components/SignupForm.js'
import Footer from '../components/Footer.js'
import CenteredWrapper from '../components/CenteredWrapper.js'
import { Spinner } from 'react-bootstrap';
import { jwt } from "jwt-decode";


export default class Nacionalidad extends Component {

    constructor(props) {
        super(props);

        this.state = {
            verInformacion: null,
            verFormRegistro: false,
            verFormRegistroExternos: false,
            modalIsOpen: false,
            modalError: false,
            modalGTSI: false,
            modalAviCamEC: false,
            modalAviCamEX: false,
            /*par que aparezca el campo y boton de consultar cedula*/
            showRenderEcuatoriano: false,
            showRenderExtranjero: false,
            modaldatosVerificado: false,
            modalNohaycuenta: false,
            modalNoExisteEnBase:false,
            activebutton: true,
            redirectHome: false,

            VarEnv: "",
            verificarDatosExt: {
                pasaporte: "",
                fechaNac: "",
                terminos: ""
            },
            verificarDatosEcu: {
                cedula: "",
                fechaEmision: "",
                terminos: ""
            },
            errorsDatosEcu: {
            },
            errorsDatosExtran: {
            },
            getVerificarUsuario: {
                id: 0,
                identificacion: "",
                nombres: "",
                apellidos: "",
                usuarios: [],
                correoAlterno: "",
                rol: "",
                telefono: "",
                unidad: ""
            },
            expresiones: {
                cedula: /^[\d]{10}$/,
                pasaporte: /^[a-zA-Z0-9._-]{4,14}$/,
            },
            modalMessage: {
                show: false,
                titulo: "",
                mensaje: "",
                imagen: ""
            },

        };
        this.verInfoEcuatoriano = this.verInfoEcuatoriano.bind(this);
        this.verInfoExtranjero = this.verInfoExtranjero.bind(this);
        this.renderFormRegistro = this.renderFormRegistro.bind(this);
        this.handlerVerificarDatos = this.handlerVerificarDatos.bind(this);
        this.abrirModal = this.abrirModal.bind(this);
        this.cerrarModal = this.cerrarModal.bind(this);

        this.abrirModalError = this.abrirModalError.bind(this);
        this.cerrarModalError = this.cerrarModalError.bind(this);

        this.setearCookie = this.setearCookie.bind(this);

        this.abrirModalMessage = this.abrirModalMessage.bind(this);
        this.cerrarModalMessage = this.cerrarModalMessage.bind(this);

        this.abrirModalInfoGTSI = this.abrirModalInfoGTSI.bind(this);
        this.cerrarModalInfoGTSI = this.cerrarModalInfoGTSI.bind(this);

        this.abrirModalAviCamEC = this.abrirModalAviCamEC.bind(this);
        this.cerrarModalAviCamEC = this.cerrarModalAviCamEC.bind(this);

        this.abrirModalAviCamEX = this.abrirModalAviCamEX.bind(this);
        this.cerrarModalAviCamEX = this.cerrarModalAviCamEX.bind(this);

        this.abrirModaldatosVeri = this.abrirModaldatosVeri.bind(this);
        this.cerrarModaldatosVeri = this.cerrarModaldatosVeri.bind(this);

        this.abrirModalnoCuenta = this.abrirModalnoCuenta.bind(this);
        this.cerrarModalnoCuenta = this.cerrarModalnoCuenta.bind(this);

        this.abrirModalnoExisteEnBase = this.abrirModalnoExisteEnBase.bind(this);
        this.cerrarModalnoExisteEnBase = this.cerrarModalnoExisteEnBase.bind(this);

        this.showrenderEcuador = this.showrenderEcuador.bind(this);
        this.showrenderExtranjero = this.showrenderExtranjero.bind(this);

        this.activebuttonf = this.activebuttonf.bind(this);
        this.activebuttonf = this.activebuttonf.bind(this);
        this.activebuttonf = this.activebuttonf.bind(this);
        this.disabledbuttonf = this.disabledbuttonf.bind(this);

    }
    
    componentWillMount() {
        this.props.useEffect();
        this.clearAllCookies();
        this.getRedirectFromExternal();
    }
   
    clearAllCookies () {
        const tempCookiesValues = [
            'identificacion',
            'tipo',
            'fechaemision',
            'fechanacimiento',
            'token',
            'DatosPersonalesGIA.CAS'
        ]
        const allCookies = Cookies.get();
    
        for (const cookie in allCookies) {
            if (tempCookiesValues.includes(cookie)) {
                Cookies.remove(cookie);
            }        
        }
    }

    getRedirectFromExternal() {        
        const hashParams = new URLSearchParams(window.location.hash.substring(1));        

        const redirect = hashParams.get("redirect");

        if (redirect) {
            if (!sessionStorage.getItem("redirect_after_register")) {
                sessionStorage.setItem("redirect_after_register", redirect);

            }
            window.history.replaceState(null, "", window.location.pathname + window.location.search);
        }

        //console.log(redirect);
    }

    activebuttonf() {
        this.setState({ activebutton: true });
    }

    disabledbuttonf() {
        this.setState({ activebutton: false });

    }


    abrirModalnoCuenta(redirectHome = false) {
        this.setState({ modalNohaycuenta: true });
        //console.log("abrir modal " + this.state.modalNohaycuenta);
        this.setState({ redirectHome: redirectHome });
    }

    cerrarModalnoCuenta() {
        this.setState({ modalNohaycuenta: false });
        //console.log("cerrar modal " + this.state.modalNohaycuenta);
    }

    abrirModalnoExisteEnBase() {
       /* this.setState({ verFormRegistroExternos: true });*/
        this.setState({ modalNoExisteEnBase: true });

    }

    cerrarModalnoExisteEnBase() {
        /*this.setState({ verFormRegistroExternos: false });*/
        this.setState({ modalNoExisteEnBase: false });
    }

    showrenderEcuador() {
        this.setState({ showRenderEcuatoriano: true });
        this.setState({ showRenderExtranjero: false });
        this.cerrarModalAviCamEC();

    }

    showrenderExtranjero() {
        this.setState({ showRenderEcuatoriano: false });
        this.setState({ showRenderExtranjero: true });
        this.cerrarModalAviCamEX();

    }

    abrirModaldatosVeri() {
        this.setState({ modaldatosVerificado: true });

    }

    cerrarModaldatosVeri() {
        this.setState({ modaldatosVerificado: false });
        this.renderFormRegistro();
    }

    abrirModalAviCamEC() {
        this.props.callTagManager("click-btn-registo-ecuatoriano");
        this.setState({ modalAviCamEC: true });
        //console.log("abrir modal " + this.state.modalAviCamEC);
    }

    cerrarModalAviCamEC() {
        this.setState({ modalAviCamEC: false });
        //console.log("cerrar modal " + this.state.modalAviCamEC);
    }

    abrirModalAviCamEX() {
        this.props.callTagManager("click-btn-registo-extranjero");
        this.setState({ modalAviCamEX: true });
        //console.log("abrir modal " + this.state.modalAviCamEC);
    }

    cerrarModalAviCamEX() {
        this.setState({ modalAviCamEX: false });
        //console.log("cerrar modal " + this.state.modalAviCamEC);
    }


    abrirModalInfoGTSI() {
        this.setState({ modalGTSI: true });
        //console.log("abrir modal " + this.state.modalGTSI);
    }

    cerrarModalInfoGTSI() {
        this.setState({ modalGTSI: false });
        //console.log("cerrar modal " + this.state.modalGTSI);
    }

    abrirModalMessage() {
        this.setState({
            modalMessage: {
                ...this.state.modalMessage,
                show: true
            }
        });
    }

    cerrarModalMessage() {
        this.setState({
            modalMessage: {
                titulo: "",
                mensaje: "",
                imagen: "",
                show: false
            }
        });
        //console.log("cerrar modal " + this.state.modalMessage);
    }


    abrirModal() {
        this.setState({ modalIsOpen: true });
        //console.log("abrir modal " + this.state.modalIsOpen);
    }

    cerrarModal() {
        this.setState({ modalIsOpen: false });
        //console.log("cerrar modal " + this.state.modalIsOpen);
    }

    abrirModalError() {

        this.setState({ modalError: true });
        //console.log("abrir modal error " + this.state.modalError);
    }

    cerrarModalError() {
        this.setState({ modalError: false })
    }

    abrirModalIdnFeInc() {
        this.setState({ modalIdnFeInc: true });
    }

    cerrarModalIdnFeInc() {
        this.setState({ modalIdnFeInc: false })
    }

    abrirModalUserExist() {
        this.setState({ modalUserExist: true });
    }

    cerrarModalUserExist() {
        this.setState({ modalUserExist: false })
    }

    //esta funcion funciona XD
    verInfoEcuatoriano() {
        this.setState({ verInformacion: true });
    }

    verInfoExtranjero() {
        this.setState({ verInformacion: false });
    }

    renderFormRegistro() {
        //console.log("render form registro");
        this.setState({ verFormRegistro: true });
    }


    handlerVerificarDatos = async (e) => {
        const { name, value, checked } = e.target

        await this.setState({
            verificarDatosExt: {
                ...this.state.verificarDatosExt,
                [name]: value,
                terminos: checked
            }
        });

        if (name === "fechaNac" && value && value.length === 10) {
            const fechaNacimiento = new Date(value);
            const hoy = new Date();

            let edad = hoy.getFullYear() - fechaNacimiento.getFullYear();
            const mes = hoy.getMonth() - fechaNacimiento.getMonth();

            if (mes < 0 || (mes === 0 && hoy.getDate() < fechaNacimiento.getDate())){
                edad --;
            }

            if (edad < 16){
                await this.setState({
                    errorsDatosExtran: {
                        ...this.state.errorsDatosExtran,
                        fechaNac: "La edad mínima permitida es 16 años",
                    }
                });
                return;
            } else {
                this.setState({
                    errorsDatosExtran: {
                        ...this.state.errorsDatosExtran,
                        fechaNac: ""
                    }
                });
            }
        } else if (name === "fechaNac" && (!value || value.length < 10)) {
            await this.setState({
                errorsDatosExtran: {
                    ...this.state.errorsDatosExtran,
                    fechaNac: ""
                }
            });
        }
        
        this.handlerOnBlurExt();
    }

    handlerVerificarDatosEcu = async (e) => {
        //console.log(this.state.verificarDatosEcu);

        await this.setState({
            verificarDatosEcu: {
                ...this.state.verificarDatosEcu,
                [e.target.name]: e.target.value,
                terminos: e.target.checked
            }
        })

        this.handlerOnBlurEcu();
    }


    handlerOnBlurEcu = async (e) => {

        if (!this.state.expresiones.cedula.test(this.state.verificarDatosEcu.cedula)) {
            await this.setState({
                errorsDatosEcu: {
                    cedula: "Identificación debe tener 10 dígitos",
                }
            })
        } else {
            this.setState({ errorsDatosEcu: {} })
        }
   
    }

    handlerOnBlurExt = async (e) => {
        if (!this.state.expresiones.pasaporte.test(this.state.verificarDatosExt.pasaporte)) {
            await this.setState({
                errorsDatosExtran: {
                    pasaporte: "Identificación debe tener entre 4 a 14 caracteres",
                }
            })
        } else {
            this.setState({ errorsDatosExtran: {} })
        }
        /*console.log("blur");
        console.log(this.state.errorsDatosExtran);*/
    }

    setearCookie() {
        this.clearAllCookies();
        //console.log(this.state.verificarDatosExt.pasaporte);
        if (this.state.verificarDatosExt.pasaporte === "") {
            Cookies.set("identificacion", this.state.verificarDatosEcu.cedula, { expires: 1 });
            Cookies.set("tipo", "cedula", { expires: 1 });
            Cookies.set("fechaemision", this.state.verificarDatosEcu.fechaEmision, { expires: 1 });
            /*Cookies.set("nombres",JSON.stringify(this.state.verificarDatosEcu.cedula),  { expires: 1 });
            Cookies.set("apellidos",JSON.stringify(this.state.verificarDatosEcu.cedula),  { expires: 1 });*/
            //console.log("cedula");
        } else {
            Cookies.set("identificacion", this.state.verificarDatosExt.pasaporte, { expires: 1 });
            Cookies.set("tipo", "pasaporte", { expires: 1 });
            Cookies.set("fechanacimiento", this.state.verificarDatosExt.fechaNac, { expires: 1 });
            //console.log("pasaporte");
        }
    }

    getVerificarUsuarioExtranj = async (e) => {
        // Se requiere mejorar esta validacion porque no se debe comprobar en el registro civil
        e.preventDefault();
        this.disabledbuttonf();
        window.grecaptcha.ready(() => {
            window.grecaptcha.execute(process.env.REACT_APP_CAPTCHAKEY, { action: 'submit' }).then(token => {
                var datos = {
                    identificacion: this.state.verificarDatosExt.pasaporte,
                    fecha: this.state.verificarDatosExt.fechaNac,
                    tipo: "pasaporte",
                };
                axios.post(`${process.env.REACT_APP_API}api/Persona/datawithoutaccount`, datos, {
                      headers: {
                        'X-Recaptcha-Token': token
                      }
                    })
                    .then(async (r) => {
                        if (r.status === 200 && r.data.success === true) {
                            this.setState({
                                getVerificarUsuario: {
                                    id: r.data.persona.persona.idsccepersona,
                                    identificacion: r.data.persona.persona.identificacion,
                                    nombres: r.data.persona.persona.nombres,
                                    apellidos: r.data.persona.persona.apellidos,
                                    usuarios: r.data.persona.usuarios,
                                    correoAlterno: r.data.persona.persona.correoalterno,
                                    rol: r.data.persona.persona.rol,
                                    telefono: r.data.persona.persona.telefono,
                                    unidad: r.data.persona.persona.unidad,
                                    alias: r.data.persona.alias
                                }
                            });
                            sessionStorage.setItem("token_nueva_cuenta", r.data.token.token);

                            this.abrirModaldatosVeri();
                            this.activebuttonf();
                        } else if (r.status === 200 && r.data.success === false) {                            
                             this.abrirModalnoCuenta(true); //USUARIO QUE NO EXISTE EN BASE
                            //await this.getUserExistsApiExt(this.state.verificarDatosExt.pasaporte, 'PAS');
                        }
                    }).catch(error => {
                        //datos incorrectos
                        this.setearCookie();
                        this.activebuttonf();
                        if (error.request.response === "") {
                            this.setState({
                                modalMessage: {
                                    show: true,
                                    titulo: "ATENCIÓN",
                                    mensaje: "Existe un problema, favor de intentarlo mas tarde.",
                                    imagen: equis,
                                }
                            });
                        } else {

                            if (error.response.data.errorMessage === "La cuenta asociada a esta identificación se encuentra inactiva") {
                                this.abrirModalInfoGTSI();
                            } else if (error.response.data.errorMessage === "Solicitud existe") {
                                this.setState({
                                    modalMessage: {
                                        show: true,
                                        titulo: "ATENCIÓN",
                                        mensaje: "Ya existe una solicitud registrada con este número de identificación que se encuentra en proceso de revisón.",
                                        imagen: info,
                                    }
                                });
                            } else if (error.response.data.errorMessage === "Ya existe una cuenta asociada a este número de identificación.") {
                                this.setState({
                                    modalMessage: {
                                        show: true,
                                        titulo: "ATENCIÓN",
                                        mensaje: "Ya existe una cuenta asociada a este número de identificación.",
                                        imagen: info,
                                    }
                                });
                            }

                            else if (error.response.data.errorMessage === "La fecha de nacimiento ingresada no es correcta") {
                                this.setState({
                                    modalMessage: {
                                        show: true,
                                        titulo: "Error",
                                        mensaje: "La fecha de nacimiento ingresada no es correcta",
                                        imagen: equis,
                                    }
                                });
                            } else {
                                this.setState({
                                    modalMessage: {
                                        show: true,
                                        titulo: "Error",
                                        mensaje: error.response.data.errorMessage,
                                        imagen: equis,
                                    }
                                });
                            }
                        }
                    });
            });
        });
    }

    getVerificarUsuarioEcu = async (e) => {
        this.props.callTagManager("click-btn-verificar-datos-ecuatoriano");
        e.preventDefault();
        this.disabledbuttonf();
        //console.log(this.state.verificarDatosEcu);

        window.grecaptcha.ready(() => {
            window.grecaptcha.execute(process.env.REACT_APP_CAPTCHAKEY, { action: 'submit' }).then(token => {
                var datos = {
                    identificacion: this.state.verificarDatosEcu.cedula,
                    fecha: this.state.verificarDatosEcu.fechaEmision,
                    tipo: "cedula",
                }
              axios.post(`${process.env.REACT_APP_API}api/Persona/datawithoutaccount`, datos, {
                      headers: {
                        'X-Recaptcha-Token': token
                      }
                    })
                    .then(async (r) => {
                        if (r.status === 200 && r.data.success === true) {
                            this.setState({
                                getVerificarUsuario: {
                                    id: r.data.persona.persona.idsccepersona,
                                    identificacion: r.data.persona.persona.identificacion,
                                    nombres: r.data.persona.persona.nombres,
                                    apellidos: r.data.persona.persona.apellidos,
                                    usuarios: r.data.persona.usuarios,
                                    correoAlterno: r.data.persona.persona.correoalterno,
                                    rol: r.data.persona.persona.rol,
                                    telefono: r.data.persona.persona.telefono,
                                    unidad: r.data.persona.persona.unidad,
                                    alias: r.data.persona.alias

                                }
                            });
                            sessionStorage.setItem("token_nueva_cuenta", r.data.token.token);

                            this.activebuttonf();
                            this.renderFormRegistro();
                        } else if (r.status === 200 && r.data.success === false) {
                            //this.abrirModalnoCuenta(); //USUARIO QUE NO EXISTE EN BASE
                            // this.abrirModalnoExisteEnBase();
                            await this.getUserExistsApiExt(this.state.verificarDatosEcu.cedula, 'CED');
                        }
                    }).catch(error => {
                        this.setearCookie();
                        //console.log(error.request.response);
                        if (error.request.response === "") {
                            this.abrirModalError();
                        } else {
                            if (error.response.data.errorMessage === "sri no funciona") {
                                this.abrirModalnoCuenta();
                            } else if (error.response.data.errorMessage === "La cedula o fecha ingresada es incorrecto.") {
                                this.setState({
                                    modalMessage: {
                                        show: true,
                                        titulo: "Error",
                                        mensaje: "La cedula o fecha ingresada es incorrecta",
                                        imagen: equis,
                                    }
                                });
                            } else if (error.response.data.errorMessage === "La cuenta asociada a esta identificación se encuentra inactiva") {
                                this.abrirModalInfoGTSI();
                            } else if (error.response.data.errorMessage === "Solicitud existe") {
                                this.setState({
                                    modalMessage: {
                                        show: true,
                                        titulo: "ATENCIÓN",
                                        mensaje: "Ya existe una solicitud registrada con este número de identificación que se encuentra en proceso de revisón.",
                                        imagen: info,
                                    }
                                });
                            } else if (error.response.data.errorMessage === "Ya existe una cuenta asociada a este número de identificación.") {
                                this.setState({
                                    modalMessage: {
                                        show: true,
                                        titulo: "ATENCIÓN",
                                        mensaje: "Ya existe una cuenta asociada a este número de identificación.",
                                        imagen: info,
                                    }
                                });
                            }else if (error.response.data.errorMessage === "La información suministrada es incorrecta.") {
                                this.setState({
                                    modalMessage: {
                                        show: true,
                                        titulo: "ATENCIÓN",
                                        mensaje: "La fecha ingresada es incorrecta.",
                                        imagen: info,
                                    }
                                });
                            } else {
                                this.setState({
                                    modalMessage: {
                                        show: true,
                                        titulo: "Error",
                                        mensaje: error.response.data.errorMessage,
                                        imagen: equis,
                                    }
                                });
                            }

                        }
                        this.activebuttonf();

                    })
            });
        });
    }

    renderExtranjero() {
        return (
            <form onSubmit={this.getVerificarUsuarioExtranj}>
                <div className="nacionalidad-container-ecuext">
                    <div className="container">
                        <div className="row ">
                            <div className="col-sm-2 col-xl-3" >
                            </div>
                            <div className="col-sm-4 col-xl-3 nacionalidad-lblinp-ecuext" >
                                <label 
                                    htmlFor="pasaporte"
                                    className="form-label text-start w-100"
                                    style={{ color: "rgb(80, 110, 163)" }}
                                >
                                    Número de pasaporte
                                </label>
                                <input
                                    className={this.state.errorsDatosExtran.pasaporte ? "nacionalidad-input-error form-control" : "form-control"}
                                    name="pasaporte"
                                    value={this.state.verificarDatosExt.pasaporte}
                                    onChange={this.handlerVerificarDatos}
                                    onBlur={this.handlerOnBlurExt} />

                                {this.state.errorsDatosExtran.pasaporte &&
                                    <p className='nacionalidad-leyenda'>{this.state.errorsDatosExtran.pasaporte}</p>
                                }
                            </div>
                          
                            <div className="col-sm-4 col-xl-3 nacionalidad-lblinp-ecuext" >
                                <label 
                                    htmlFor="fechaNac"
                                    className="form-label text-start w-100  nacionalidad-lblinp-ecuext" 
                                    style={{ color: "rgb(80, 110, 163)" }}
                                >
                                    Fecha de nacimiento
                                </label>
                                <input 
                                    type="date" 
                                    className="form-control" 
                                    name="fechaNac" 
                                    value={this.state.verificarDatosExt.fechaNac} 
                                    onChange={this.handlerVerificarDatos} 
                                    min="1900-01-01"
                                    max="2099-12-31"
                                />

                                {this.state.errorsDatosExtran.fechaNac &&
                                    <p className='nacionalidad-leyenda'>{this.state.errorsDatosExtran.fechaNac}</p>
                                }
                            </div>
                        </div>
                        
                        <div className="row align-items-center">
                            <div className=" col-xl-12 " align="center">
                                {/*<div className="container-btn-verificar">*/}
                                <div>
                                    <button
                                        disabled={this.state.verificarDatosExt.pasaporte && this.state.activebutton && this.state.verificarDatosExt.fechaNac
                                            && !this.state.errorsDatosExtran.pasaporte ? false : true}
                                        type="submit"
                                        className={this.state.verificarDatosExt.pasaporte &&  this.state.activebutton &&
                                            this.state.verificarDatosExt.fechaNac
                                            && !this.state.errorsDatosExtran.pasaporte ? "nacionalidad-btn-verificar" : "nacionalidad-btn-verificar-disabled"}>
                                        VERIFICAR
                                    </button>
                                    {!this.state.activebutton ?
                                        <span className="registroContra-fr-top spinner-border text-primary ms-2" role="status" aria-hidden="true"></span>
                                        : null}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>

        );

    }

    renderEcuatoriano() {
        return (            
            <form onSubmit={this.getVerificarUsuarioEcu}>
                <div className="nacionalidad-container-ecuext">
                    <div className="row" >
                        <div className="col-sm-2 col-xl-3"></div>
                        <div className="col-sm-4 col-xl-3 nacionalidad-lblinp-ecuext ">
                            <label 
                                htmlFor="cedula"
                                className="form-label  text-start w-100"
                                style={{ color: "rgb(80, 110, 163)" }}
                            >
                                Número de cédula
                            </label>
                            <input type="text" className={this.state.errorsDatosEcu.cedula ? "nacionalidad-input-error form-control" : "form-control"}
                                name="cedula" value={this.state.verificarDatosEcu.cedula}
                                onChange={this.handlerVerificarDatosEcu}
                                onBlur={this.handlerOnBlurEcu} />
                            {this.state.errorsDatosEcu.cedula &&
                                <p className='nacionalidad-leyenda'>{this.state.errorsDatosEcu.cedula}</p>
                            }
                        </div>

                        <div className="col-sm-4 col-xl-3 nacionalidad-lblinp-ecuext">
                            <label 
                                htmlFor="fechaEmision"
                                className="form-label  text-start w-100"
                                style={{ color: "rgb(80, 110, 163)" }}
                            >
                                Fecha emisión de cédula
                            </label>
                            <input 
                                type="date" 
                                className="form-control" 
                                name="fechaEmision" 
                                value={this.state.verificarDatosEcu.fechaEmision} 
                                onChange={this.handlerVerificarDatosEcu}
                                min="1900-01-01"
                                max="2099-12-31"
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 col-xl-12 " align="center">
                            <div>
                                <button

                                    disabled={this.state.verificarDatosEcu.cedula &&
                                        this.state.verificarDatosEcu.fechaEmision &&

                                        this.state.activebutton &&
                                        !this.state.errorsDatosEcu.cedula ? false : true}
                                    type="submit"
                                    className={this.state.verificarDatosEcu.cedula &&
                                        this.state.verificarDatosEcu.fechaEmision &&

                                        this.state.activebutton &&
                                        !this.state.errorsDatosEcu.cedula ?
                                        "nacionalidad-btn-verificar" : "nacionalidad-btn-verificar-disabled"}>VERIFICAR</button>
                                {!this.state.activebutton ?
                                    <span className="registroContra-fr-top spinner-border text-primary ms-2" role="status" aria-hidden="true"></span>
                                    : null}
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        );
    }

    getUserExistsApiExt(identificacion, tipo) {
        // this.setState({ loading: true });
        this.setearCookie();
        window.grecaptcha.ready(()=>{
            window.grecaptcha.execute(process.env.REACT_APP_CAPTCHAKEY, { action: 'submit' }).then(token => {
                axios.get(`${process.env.REACT_APP_API_EXT}/Account/VerificarExistenciaPersona`, {
                    params: {
                        tipoidentificacion: tipo,
                        numidentificacion: identificacion
                    },
                    headers: {
                        'X-Recaptcha-Token': token
                    }
                })
                .then(response => {                    
                    const existe = response.data.data.respuesta === undefined ? response.data.data.existe : response.data.data.respuesta;
                    if (response.data.status.isSuccessfully && existe) {
                        const corr= response.data.data.email;
                        console.log("El usuario aun no puede crear cuenta institucional, no consta en las vistas.");
                        this.setState({
                            modalMessage: {
                                show: true,
                                titulo: "ATENCIÓN",
                                mensaje: "Ya existe una cuenta creada con el usuario "+corr+", aún no se cumplen las condiciones para obtener una cuenta con el dominio espol.edu.ec.",
                                imagen: info,
                            }
                        });
                        this.activebuttonf();
                    } else {
                        window.location.href = '/solicitud';
                    }
                })
                .catch(error => {            
                    this.activebuttonf();
                    this.setState({
                        modalMessage: {
                            show: true,
                            titulo: "Error",
                            mensaje: "Lo sentimos, vuelva a intentar.",
                            imagen: info,
                        }
                    });
                });
            });
        });
    }

    render() {
        /*if(this.state.verFormRegistroExternos) {
            return (               
                <SignupForm 
                    identificacion={this.state.verificarDatosEcu.cedula}
                />
            )
        }*/
        return (

            this.state.verFormRegistro ?
                <FormRegistro
                    id={this.state.getVerificarUsuario.id}
                    identificacion={this.state.getVerificarUsuario.identificacion}
                    nombres={this.state.getVerificarUsuario.nombres}
                    apellidos={this.state.getVerificarUsuario.apellidos}
                    correoAlterno={this.state.getVerificarUsuario.correoAlterno}
                    rol={this.state.getVerificarUsuario.rol}
                    telefono={this.state.getVerificarUsuario.telefono}
                    unidad={this.state.getVerificarUsuario.unidad}
                    usuarios={this.state.getVerificarUsuario.usuarios}
                    alias_sugerido={this.state.getVerificarUsuario.alias}
                    callTagManager={this.props.callTagManager}
                    /*useEffect={this.props.useEffect}*/
                ></FormRegistro>
                : (
                    <div>
                        <Header />
                        <CenteredWrapper>
                            <div className="nacionalidad-container">                    
                            {!this.state.showRenderEcuatoriano && !this.state.showRenderExtranjero ?                                
                                <>
                                    <div className="row-nacionalidad-title">
                                        <div className="col-12 col-sm-10 col-xl-8 title_crear_cuenta">
                                            <div>
                                                <p className="nacionalidad-title"><b>Para proceder a crear su cuenta, seleccione su tipo de ciudadanía:</b></p>
                                            </div>
                                        </div>
                                    </div>

                                    <div id="nacionalidad-div-btns">
                                            <div className="row-nacionalidad-btns">
                                                {/* <div className="col-sm-2 col-xl-2"></div> */}
                                                <div className="col-12 col-md-4 nacionalidad-btn-margin" align="center">
                                                    <button onClick={this.showrenderEcuador} className="nacionalidad-btn">
                                                        <img src={ecuatoriano} className="nacionalidad-btn-logop" />
                                                        <span className="nacionalidad-btn-txt" >Ciudadano Ecuatoriano</span>
                                                    </button>
                                                </div>
                                                {/* <div className="col-sm-2 col-xl-2"></div> */}
                                                <div className="col-12 col-md-4 nacionalidad-btn-margin" align="center">
                                                    <button onClick={this.showrenderExtranjero} className="extranjero-btn">
                                                        <img src={extranjero} className="nacionalidad-btn-logop" />
                                                        <span className=" nacionalidad-btn-txt" >Ciudadano Extranjero</span>
                                                    </button>
                                                </div>
                                            </div>
                                    </div>
                                </>

                                : null
                            }
                            {(this.state.showRenderEcuatoriano || this.state.showRenderExtranjero) && (
                            <>
                                <div className="row-nacionalidad-title">
                                <div className="col-12 col-sm-10 col-xl-8 title_crear_cuenta">
                                    <div>
                                    <p className="nacionalidad-title"><b>Ingrese los siguientes datos:</b></p>
                                    </div>
                                </div>
                                </div>

                                {this.state.showRenderEcuatoriano && !this.state.showRenderExtranjero && this.renderEcuatoriano()}
                                {!this.state.showRenderEcuatoriano && this.state.showRenderExtranjero && this.renderExtranjero()}
                            </>
                            )}                            
                            </div>
                        </CenteredWrapper>
                        <Footer />

                        {
                            this.state.modaldatosVerificado &&
                            <Modal isOpen={this.state.modaldatosVerificado} cerrarModal={this.cerrarModaldatosVeri} verBoton={false} textoBoton="ACEPTAR" >
                                {/*<p className='text-center'><strong>¡OBLIGATORIO!</strong></p>*/}
                                <div className='mt-6 mb-6' align="center">
                                    <img className="nacionalidad-modal-logos-transexitosa" src={transaccionexitosa} alt="Error"></img>
                                </div>
                                <br />
                                <p className='text-center '><i>Sus datos han sido verificado con éxito</i></p>

                                <p className='text-center nacionalidad-modal-letras'><strong>Proceda con los pasos solicitados para culminar con la creación de cuenta.</strong></p>
                                <br />
                                <div align="center" >
                                    <button className="nacionalidad-modal-botones" onClick={this.renderFormRegistro} >SIGUIENTE </button>
                                </div>
                            </Modal>
                        }

                        {
                            this.state.modalAviCamEC &&
                            <Modal isOpen={this.state.modalAviCamEC} cerrarModal={this.cerrarModalAviCamEC} verBoton={false} textoBoton="ACEPTAR" >
                                <p className='text-center'><strong>¡OBLIGATORIO!</strong></p>
                                <div className='mt-6 mb-6' align="center">
                                    <img className="nacionalidad-modal-logos" src={camaranecesaria} alt="Error"></img>
                                </div>
                                <p className='text-center nacionalidad-modalECEX-texto'><b>Para continuar con la creación de cuenta electrónica es necesario que disponga de un dispositivo con
                                    cámara habilitada</b></p>
                                <div align="center" >
                                    <button className="nacionalidad-modal-botones" onClick={this.showrenderEcuador} >CONTINUAR </button>
                                </div>
                            </Modal>
                        }

                        {
                            this.state.modalAviCamEX &&
                            <Modal isOpen={this.state.modalAviCamEX} cerrarModal={this.cerrarModalAviCamEX} verBoton={false} textoBoton="ACEPTAR" >
                                <p className='text-center'><strong>¡OBLIGATORIO!</strong></p>
                                <div className='mt-6 mb-6' align="center">
                                    <img className="nacionalidad-modal-logos" src={camaranecesaria} alt="Error"></img>
                                </div>
                                <p className='text-center nacionalidad-modalECEX-texto'><b>Para continuar con la creación de cuenta electrónica es necesario que disponga de un dispositivo con
                                    cámara habilitada</b></p>
                                <div align="center" >
                                    <button className="nacionalidad-modal-botones" onClick={this.showrenderExtranjero} >CONTINUAR </button>
                                </div>
                            </Modal>
                        }

                        {
                            this.state.modalNohaycuenta &&
                            <ModalXL isOpen={this.state.modalNohaycuenta} cerrarModal={this.cerrarModalnoCuenta} verBoton={false} textoBoton="ACEPTAR" >

                                <div className='mt-6 mb-6 nacionalidad-modalnocuenta-div' align="center">
                                    <img className="nacionalidad-modalnocuenta-logos" src={alarma} alt="Error"></img>
                                </div>
                                <p className='text-center nacionalidad-modalnocuenta-texto '>Sus datos han sido verificados y<b> no existe coincidencia con ningún perfil </b>como:</p>

                                <ul className='text-justify nacionalidad-modalnocuenta-texto'>
                                    <b><li>Ser miembro de la ESPOL como docente, administrativo o estudiante.</li>
                                        <li>Docente o administrativo con contrato regularizado con Talento Humano.</li>
                                        <li>Estudiante con matrícula en ESPOL.</li>
                                        <li>No tener cuenta de correo en ESPOL.</li></b>
                                </ul>                                
                                <div align="center" >
                                    {
                                        this.state.redirectHome ?
                                        <Link to="/inicio">
                                            <button className='nacionalidad-modalnocuenta-botones' >SEGUIR</button>
                                        </Link>
                                        :
                                        <Link to="/solicitud">
                                            <button className='nacionalidad-modalnocuenta-botones' >SEGUIR</button>
                                        </Link>
                                    }
                                </div>
                            </ModalXL>
                        }
       {
                            this.state.modalNoExisteEnBase &&
                            <Modal isOpen={this.state.modalNoExisteEnBase} cerrarModal={this.cerrarModalnoExisteEnBase} verBoton={false} textoBoton="ACEPTAR" >
                                    <div className='mt-6 mb-6 nacionalidad-modalnocuenta-div' align="center">
                                        <img className="nacionalidad-modalnocuenta-logos" src={alarma} alt="Error"></img>
                                    </div>
                                    <p className='text-center nacionalidad-modalnocuenta-texto '>Sus datos han sido verificados y<b> no existe coincidencia con ningún perfil. </b></p>
                                    <p className="text-center">
                                        <strong>Puede comunicarse con Gerencia de Tecnologías y Servicios de Información</strong></p>
                                    <div className="text-center inactiva-contacto">
                                        <table>
                                            <tr>
                                                <td ><strong>Teléfono: </strong></td>
                                                <td className="nacionalidad-centerTable">(+593) 42269256 </td>
                                            </tr>
                                            <tr>
                                                <td><strong>Atención: </strong></td>
                                                <td className="nacionalidad-centerTable">Lunes a Viernes de 08:00 a 16:00</td>
                                            </tr>
                                            <tr>
                                                <td><strong>Correo: </strong></td>
                                                <td className="nacionalidad-centerTable"><a href="mailto:gerenciatecnologia@espol.edu.ec?" >gerenciatecnologia@espol.edu.ec</a></td>
                                            </tr>
                                        </table>
                                    </div>
                                    
                            </Modal>
                        }

                        {this.state.modalIsOpen && (
                            <Modal isOpen={this.state.modalIsOpen} cerrarModal={this.cerrarModal} verBoton={false} >
                                <h4 className='text-center'><strong>Usuario no registrado</strong></h4>
                                <div className='mt-6 mb-6'>
                                    <img className="admin-check" src={equis} alt="Eliminar"></img>
                                </div>
                                <p className='text-center'>
                                    <strong>Usted no se encuentra registrado en el
                                        sistema de GTSI, llene el siguiente formulario</strong>
                                </p>
                                <div className='nacionalidad-container-btnModal'>
                                    <Link className="link" to="/solicitud">
                                        <button className='nacionalidad-btnModal'>LLENAR FORMULARIO</button>
                                    </Link>
                                </div>
                            </Modal>
                        )}


                        {this.state.modalError &&
                            <Modal isOpen={this.state.modalError} cerrarModal={this.cerrarModalError} verBoton={true} textoBoton="ACEPTAR" >
                                <p className='text-center'><strong>Error en la Solicitud</strong></p>
                                <div className='mt-6 mb-6' align="center">
                                <img className="nacionalidad-check" src={equis} alt="Error"></img>
                                </div>
                                <p className='text-center'>Error en la solicitud, intentelo mas tarde</p>
                            </Modal>
                        }


                        {this.state.modalMessage.show &&
                            <Modal isOpen={this.state.modalMessage.show} cerrarModal={this.cerrarModalMessage} verBoton={true} textoBoton="ACEPTAR" >
                                <p className='text-center'><strong>{this.state.modalMessage.titulo}</strong></p>
                                <div className='mt-6 mb-6' align="center">
                                <img className="nacionalidad-check" src={this.state.modalMessage.imagen} alt="Exitoso"></img>
                                </div>
                                <p className='text-center'>{this.state.modalMessage.mensaje}</p>
                            </Modal>
                        }

                        {this.state.modalGTSI &&
                            <Modal isOpen={this.state.modalGTSI} cerrarModal={this.cerrarModalInfoGTSI} verBoton={false}>
                                <p className="text-center">
                                    <strong>Comunicarse con Gerencia de Tecnologías y Servicios de Información</strong></p>
                                <p className="text-center">Su cuenta se encuentra <strong> inactiva.</strong></p>
                                <div className="text-center inactiva-contacto">
                                    <table>
                                        <tr>
                                            <td ><strong>Teléfono: </strong></td>
                                            <td className="nacionalidad-centerTable">(+593) 42269256 </td>
                                        </tr>
                                        <tr>
                                            <td><strong>Atención: </strong></td>
                                            <td className="nacionalidad-centerTable">Lunes a Viernes de 08:00 a 16:00</td>
                                        </tr>
                                        <tr>
                                            <td><strong>Correo: </strong></td>
                                            <td className="nacionalidad-centerTable"><a href="mailto:gerenciatecnologia@espol.edu.ec?" >gerenciatecnologia@espol.edu.ec</a></td>
                                        </tr>
                                    </table>
                                </div>

                            </Modal>
                        }
                    </div>
                )
        );


    }
}
